// extracted by mini-css-extract-plugin
export default {"iframe-fullscreen-button":"IframeFullscreenButton_iframe-fullscreen-button__8KKyc"};